import { render, staticRenderFns } from "./UpdateAvailableNotification.vue?vue&type=template&id=92a3f6aa&"
import script from "./UpdateAvailableNotification.vue?vue&type=script&lang=ts&"
export * from "./UpdateAvailableNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports